import { useRecoilState } from "recoil";
import React from "react";
import { InputBase } from "../../../../components";
import { addMeterState } from "../atoms/atoms";

type Props = {
  type: string;
  name: string;
  placeholder: string;
  className: string;
};

const Input: React.FC<Props> = ({
  type,
  name,
  placeholder,
  className,

  ...props
}: Props) => {
  const [state, setState] = useRecoilState(addMeterState);
  return (
    <InputBase
      {...props}
      type={type}
      name={name}
      placeholder={placeholder}
      state={state}
      setState={setState}
      className={className}
    />
  );
};

export default Input;
